/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowpicturesonly3Inputs */

const en_aiflowpicturesonly3 = /** @type {(inputs: Aiflowpicturesonly3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please fill in from the pictures`)
};

const de_aiflowpicturesonly3 = /** @type {(inputs: Aiflowpicturesonly3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte aus den Bildern ausfüllen`)
};

/**
* | output |
* | --- |
* | "Please fill in from the pictures" |
*
* @param {Aiflowpicturesonly3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowpicturesonly3 = /** @type {((inputs?: Aiflowpicturesonly3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowpicturesonly3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowpicturesonly3(inputs)
	return de_aiflowpicturesonly3(inputs)
});
export { aiflowpicturesonly3 as "aiFlowPicturesOnly" }